import { useMemo } from 'react';
import TrainMeBody from '../TrainMe/TrainMeBody.jsx';
import { mapClaimToTrainMeDetail } from '../../../utils/mapClaimToTrainMeDetail.js';

/**
 * Train Me detail body for an interim `claim_suggestion` event (CT-5095).
 *
 * Renders the EVT-011 prototype layout (`SubmissionBlock` → `EditBlock` →
 * `ImpactBlock`) by mapping real claim-suggestion list + preview fields into the
 * Train Me detail shape — see `utils/mapClaimToTrainMeDetail.js` for the field
 * matrix and backend gaps (commented on CT-5095).
 */
function ClaimSuggestionBody({ event }) {
  const detail = useMemo(() => mapClaimToTrainMeDetail(event), [event]);
  const hasContent =
    detail.proposedValue || detail.note || detail.submitter || detail.sourceRecord;

  if (!hasContent) {
    return (
      <p className="text-sm leading-relaxed text-content-secondary">
        {event.situation ?? event.description}
      </p>
    );
  }

  return <TrainMeBody event={{ ...event, detail }} />;
}

export default ClaimSuggestionBody;
